// src/components/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = {
  name: "D10 Pizza Fantasista",
  domain: "https://www.d10s.pizza", // change to your real domain
  defaultTitle: "D10 Pizza Fantasista — Pizza & Football by the Sea",
  defaultDescription:
    "Neapolitan ruota di carro pizza on Prosika Beach in Pag. Great dough, high-heat oven, and matchday energy.",
  defaultOgImage: "/img/og/default.png", // ensure this exists
  twitter: "@d10spizza", // optional
};

export default function SEO({
  title,
  description,
  image,
  canonical,
  noindex = false,
  type = "website",
  jsonLd,
}) {
  const { pathname } = useLocation();

  const fullTitle = title ? `${title} | ${SITE.name}` : SITE.defaultTitle;
  const metaDescription = description || SITE.defaultDescription;

  const canonicalUrl =
    canonical || `${SITE.domain}${pathname === "/" ? "" : pathname}`;

  const ogImage =
    image?.startsWith("http") ? image : `${SITE.domain}${image || SITE.defaultOgImage}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />

      <link rel="canonical" href={canonicalUrl} />

      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {SITE.twitter && <meta name="twitter:site" content={SITE.twitter} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />

      {/* Optional JSON-LD */}
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
